import { AttributesMixin, define, type } from "@type-r/models";
import { matchString } from "api/common";
import { asTimelessDate } from "lqx-react/lib";
import { AssetChange } from "./assetChange";
import { AssetEvent, AssetEventStatus } from "./assetEvent";
import { AssetType } from "./assetType";
import { restfulIO } from "./endpoint";
import { Invoice } from "./invoice";

export interface MultipleAssetChange extends AttributesMixin<typeof MultipleAssetChange> { }
@define
export class MultipleAssetChange extends AssetChange {
    static endpoint = restfulIO('api/v1/ingest/multipleassets/assets');

    static attributes = {
        ...AssetChange.attributes,
        updateAsset: Invoice,
        assetType: type(Number).value(AssetType.multiAsset),
        assetEvents: type([AssetEvent]).value([]).dontSave
    };

    getAssetType() {
        return AssetType.multiAsset;
    }

    getAssetName() {
        return 'Multiple Assets';
    }

    get paymentReferenceNumber(): String {
        return this.getValue("paymentReferenceNumber");
    }

    get paymentDate(): Date {
        const value = this.getValue("paymentDate");
        return value ? new Date(value) : null;
    }

    get paymentAmount(): String {
        return this.getValue("paymentAmount");
    }

    hasPendingAssetEventsFor(eventTypeId: number): boolean {
        return this.assetEvents.filter(ae => ae.status == AssetEventStatus.pending && ae.eventTypeId == eventTypeId).length > 0;
    }

    filter(filter) {
        return (matchString(this.paymentReferenceNumber.toString(), filter.search) ||
            matchString(this.paymentAmount.toString(), filter.search) ||
            matchString(asTimelessDate(this.paymentDate), filter.search) ||
            matchString(this.state.name, filter.search)) &&
            this.hasReceivedAssetEventsFor(filter.eventType);
    }
}
